module.exports = __webpack_public_path__ + "static/scale-model-of-see-science-center-in-manchester-new-hampshire-1fcaa3d449bce5393a400df8e35e783f.png";